import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
// import Alert from "react-bootstrap/Alert";
import { Container } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import ODMTabs from "../../components/odm/ODMTabs";
import Notifications from "../../components/push-notifications/Notifications";
import WelcomeUser from "../../components/Open-pages/user/WelcomeUser";

const OneDayMembershipOpen = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // const isNotificationDenied = useSelector(
  //   (state) => state.notification.permission
  // );

  const [pageState, setPageState] = useState(
    JSON.parse(localStorage.getItem("pageState"))
  );
  const { decryptedText: userInfoData, isCustom } = pageState || {};

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  useEffect(() => {
    const savedState = localStorage.getItem("pageState");

    if (savedState) {
      try {
        setPageState(JSON.parse(savedState));
      } catch (error) {
        console.error("Error parsing saved state:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!pageState) {
      navigate("/open-access", { state: { from: location.pathname } });
    }
  }, [pageState]);

  return (
    <HelmetWrapper title="WTF: One Day Membership">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <div className="mt30">
          <WelcomeUser userName={userInfoData?.name} />

          {userInfoData && !isIOS() && (
            <Notifications authData={userInfoData} />
          )}

          {/* {isNotificationDenied === "denied" && (
            <Alert variant={"danger"} className="mt30">
              Notification permission is denied. Unable to display desktop
              notifications.
            </Alert>
          )} */}
        </div>

        <ODMTabs userInfoData={userInfoData} isCustom={isCustom} />
      </Container>
    </HelmetWrapper>
  );
};

export default OneDayMembershipOpen;
